import * as React from "react";
import styleable from "react-styleable";
import * as inputStyle from '../../../css/components/mainlayout/PortalRadioButtons.css';

/**
 * ## styleable
 * * **container** Styling for the container.
 * * **checkmark** Styling for the checkmark.
 * * **input** Styling for the radio button.
 *
 * ## Background color settings css
 * ```
 * .container:hover input ~ .checkmark {
 *   background-color: #d9d9d9;
 *}
 *
 * .container input:checked ~ .checkmark {
 *    background-color: #2968A5;
 *}
 * ```
 *
 * @property {string} props.children
 * @property {boolean} props.value - The radio button defaults to 'unchecked', which is indicated by a value of 'false', when props.value is set to true, the radio button will be checked and an onChange event will be called on mount.
 * @property {function} props.onChange - On change event, an argument true/false is passed, which indicates the value of the radio button (checked/unchecked)
 */
class PortalRadioButton extends React.Component<any, any> {

    constructor(){
        super(undefined); // TODO: undefined
        this.state = {
            value: false,
        }
    }

    componentWillMount(){
        if(this.props.value === true){
            this.setState({
                value: this.props.value
            });
            if(this.props.onChange !== undefined)
                this.props.onChange(this.props.value)
        }
    }

    render() {

        return (
            <label className={this.props.css.container}>{this.props.children}
              <input className={this.props.css.input} type="radio" checked={this.props.value === true} onChange={(e) => {
                  let newStateValue = e.target.checked;
                  this.setState({value:newStateValue})
                  if(this.props.onChange !== undefined){
                      this.props.onChange(newStateValue);
                  }
              }}/>
              <span className = {this.props.css.checkmark}></span>
            </label>
        );
    }
}
export default styleable(inputStyle)(PortalRadioButton);